module.exports = __webpack_public_path__ + "img/bank-submit.a68b6827.png";